import lcs from "./lcs";
const comparsion = {
  run: (doc1, doc2) => {
    let { blocks: blocks1, keys: keys1 } = comparsion.getContentBlocks(doc1);
    let { blocks: blocks2, keys: keys2 } = comparsion.getContentBlocks(doc2);
    let dom1 = comparsion.getRenderDom(doc1);
    let dom2 = comparsion.getRenderDom(doc2);

    let compareResult = lcs.compare(blocks1, blocks2);
    let message = [];

    lcs.run(compareResult, 0, 0, function (i, j) {
      if (compareResult[i][j].status === lcs.DELETION) {
        if (keys1[j]) {
          let el = dom1.querySelector(`[data-blockid="${keys1[j]}"]`);
          if (el) {
            el.setAttribute("title", "Появилось в версии " + doc2.version);
            el.classList.add("comparsion--add");
          }
        }
        message.push(`Miss ${j} - ${keys1[j]}`);
      } else if (compareResult[i][j].status === lcs.INSERTION) {
        if (keys2[i] && keys1[j]) {
          let el1 = dom1.querySelector(`[data-blockid="${keys1[j]}"]`);
          let el2 = dom2.querySelector(`[data-blockid="${keys2[i]}"]`);
          if (el1 && el2) {
            el2.setAttribute(
              "title",
              "Отсутствует или изменено в версии " + doc2.version
            );
            el2.classList.add("comparsion--miss");
            el1.appendChild(el2);
          }
        }
        message.push("Add  " + j + " " + i);
      }
    });

    return dom1.innerHTML;
  },
  getRenderDom: (doc = {}) => {
    let el = document.createElement("div");
    el.innerHTML = doc.rendered || "";
    return el;
  },
  getContentBlocks: (doc = {}) => {
    let blocks = [];
    let keys = [];
    let content = JSON.parse(doc.content || "{}") || {};
    if (Array.isArray(content.blocks)) {
      content.blocks.forEach((block) => {
        if (block.text) {
          blocks.push(block.text);
          keys.push(block.key);
        }
      });
    }
    return { keys, blocks };
  },
};
export default comparsion;
